import script from "./EtcdSnapshotConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./EtcdSnapshotConfig.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__